import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import { links, constants } from 'common/helpers'
import { useFeatures, useMedia } from 'sb-hooks'
import { FormattedMessage, FormattedHTMLMessage } from 'sb-react-intl'

import { Button } from 'components/_new/controls'
import { Box } from 'components/_new/layout'

import messages from './messages'
import s from './WeMissedYouContent.scss'

import mariyaImage from './images/mariya@2x.png'
import birdImage from './images/bird@2x.png'


const WeMissedYouContent = (props) => {
  const { firstName, countOfClosings, hasLEPInQueueFirstMonth, isLEPNeedUpdateCard, currentMonth, onClose } = props
  const { [constants.features.billingDay1stDayOfTheMonth]: isBillingDay1stEnabled } = useFeatures()
  const { isMobile } = useMedia()

  const imageBoxClassName = s.imageBox
  const textContainerClassName = cx(s.textContainer, {
    [s.modal1]: !countOfClosings,
    [s.modal2]: countOfClosings,
  })

  return (
    <Fragment>
      <div className={textContainerClassName}>
        {
          Boolean(countOfClosings) ? (
            <div className={imageBoxClassName}>
              <img className={s.birdImage} src={birdImage} alt="" />
            </div>
          ) : (
            <div className={imageBoxClassName}>
              <img className={s.mariyaImage} src={mariyaImage} alt="" />
              <FormattedHTMLMessage
                className={s.imageCaption}
                {...messages.imageCaption}
              />
            </div>
          )
        }
        <div className={s.messageBox}>
          <FormattedHTMLMessage
            className={s.bold}
            {...messages.firstName}
            values={{ firstName }}
          />
          {
            (() => {
              if (isLEPNeedUpdateCard) {
                return (
                  <FormattedHTMLMessage tag="div" {...messages.textLEPNeedUpdateCard} />
                )
              }

              if (hasLEPInQueueFirstMonth) {
                const message = isBillingDay1stEnabled ? messages.textWithLEPInfo1st : messages.textWithLEPInfo

                return (
                  <FormattedHTMLMessage tag="div" {...message} values={{ currentMonth }} />
                )
              }

              return (
                <Fragment>
                  <FormattedHTMLMessage tag="div" {...messages.text} />
                  <FormattedMessage {...messages.subText} />
                </Fragment>
              )
            })()
          }
        </div>
      </div>
      <Box mt={24} mb={16}>
        <Button
          title={messages.button}
          color="brand"
          size="md"
          to={links.cardUpdate}
          fullWidth={isMobile}
          dataTestId="cardUpdateButton"
          onClick={onClose}
        />
      </Box>
      <FormattedHTMLMessage className={s.contactInfo} {...messages.contactInfo} />
    </Fragment>
  )
}

WeMissedYouContent.propTypes = {
  firstName: PropTypes.string,
  countOfClosings: PropTypes.number,
  hasLEPInQueueFirstMonth: PropTypes.bool,
  isLEPNeedUpdateCard: PropTypes.bool,
  currentMonth: PropTypes.string,
  onClose: PropTypes.func.isRequired,
}

WeMissedYouContent.defaultProps = {
  firstName: '',
  countOfClosings: 0,
  hasLEPInQueueFirstMonth: false,
  isLEPNeedUpdateCard: false,
}


export default WeMissedYouContent
